module.exports = __webpack_public_path__ + "static/img/050604.d3182269.png";